export default async function QueryDatabase({ user, table, method, filter, data}) {
    const errorReturn = new Promise(resolve => resolve(-1))

    var fetchUrl = "/api/";
    var fetchProps = {}
    var searchParams = {
        user: user
    }

    switch (method) {
        case 0://add/update
            fetchUrl += "add";
            fetchUrl += table;
            fetchProps = {
                ...fetchProps,
                body: JSON.stringify(data),
                method: "POST"
            }
            break;
        case 1://delete
            fetchUrl += "delete"
            fetchUrl += table;
            searchParams = {
                id:data
            }
            fetchProps = {
                ...fetchProps,
                method: "DELETE"
            }
            break;
        case 2://search
            fetchUrl += "get";
            fetchUrl += table;
            searchParams = {
                ...searchParams,
                filter: filter,
                search: data
            }
            fetchProps = {
                ...fetchProps,
                method: "GET"
            }
            break;
        case 3://login
            fetchUrl += "login";
            fetchProps.body = JSON.stringify(data);
            fetchProps.method = "POST";
            break;
        case 4://signup
            fetchUrl += "signup";
            fetchProps.body = JSON.stringify(data);
            fetchProps.method = "POST";
            break;
        case 5:
            fetchUrl += "update";
            fetchUrl += table;
            if(data.Cancelled_Ingredient)
                fetchUrl += "cancel"
            if(data.Planned_Ingredient)
                fetchUrl += "split"
            if(filter === "ingredients")
                fetchUrl += "transfer"
            fetchProps = {
                ...fetchProps,
                body: JSON.stringify(data),
                method: "PUT"
            }
            break;
        default:
            return errorReturn;
    }

    fetchUrl += "?" + new URLSearchParams(searchParams)

    try {
        const response = await fetch(fetchUrl, fetchProps);
        
        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error)
        return errorReturn;
    }
}